import useApiQuery from 'shared/hooks/use-api-query';
import usersKeys from '../util/users-keys';
import {UserProps} from '../types';

const useUser = (userId?: string) => {
  return useApiQuery<UserProps>({
    url: `/users/${userId}`,
    queryKey: usersKeys.details(userId!),
    enabled: !!userId,
  });
};

export default useUser;
